// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --tw-bg-opacity: 0.5; /* Adjust the opacity as needed */
}

* {
  font-size: 20px !important;
}

body {
  background-color: #000000;
}

.desk {
  cursor: url() !important;
  background-attachment: fixed;

  background-repeat: no-repeat !important;
  background-size: cover !important;
}

.mob {
  background-attachment: fixed;
  background-image: url('') !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;

  /* Set the background color with opacity and color using a CSS variable */
}

/* Additional font-face rules if you have more fonts */

/* Define global font styles */

.top_nav {
  font-size: 24px;
}

.a {
  background-color: rgb(239, 183, 0) !important;
  font-size: 17px !important;
  text-decoration: underline !important;
}
@media screen and (min-width: 1000px) {
  .a {
    background-color: rgb(239, 183, 0) !important;
    font-size: 20px !important;
    text-decoration: underline !important;
  }
}

.header-img {
  height: 18px;
}

.header-img-logo {
  height: 60px;
}

.hr_first {
  height: 11px !important;
  border-width: 0 !important;
  color: rgb(0, 47, 255) !important;
  background-color: rgb(255, 17, 0) !important;
}

.HarryPotterObamaSonic10Inu {
  background: linear-gradient(to right, #e0b700, #eed600) !important;
  font-weight: 800;
  font-size: 20px;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
@media screen and (min-width: 1000px) {
  .HarryPotterObamaSonic10Inu {
    background: linear-gradient(to right, #e0b700, #eed600) !important;
    font-weight: 800;
    font-size: 30px;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
  }
}
.ca {
  font-size: 1rem;
  color: #fff;
  font-weight: 600;
}
@media screen and (min-width: 1000px) {
  .ca {
    font-size: 1.3rem;
    color: #fff;
    font-weight: 600;
  }
}

.addy {
  color: #26c6da;
}

.top_a {
  width: 100%;
  height: 100%;
}

.header-imgs {
  height: 108px;
}

.cas {
  font-size: 2.3rem;
  color: #fff;
  font-weight: 600;
}

.top_as {
  width: 60%;
  height: 100%;
}

.cass {
  font-size: 1.3rem;
  color: #70fff3;
  font-weight: 600;
}

.hr_firsts {
  height: 4px !important;

  color: rgb(255, 255, 255) !important;
  background-color: rgb(255, 255, 255) !important;
}

.button_back {
  background-color: rgba(255, 255, 255, 0.748) !important;
  border-radius: 15px !important;
}

.iframe-container {
  position: relative;
  width: 100%;
  /* 16:9 aspect ratio (height / width) */
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}

.iframe-containerz {
  position: relative;
  width: 100%;
  /* 16:9 aspect ratio (height / width) */
}

.iframe-containerz iframe {
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}

.modl {
  background-color: #26c5da15 !important;
}
.yes-no-buttons {
  background-color: rgb(0, 0, 0) !important;
  color: rgb(255, 255, 255) !important;
  box-shadow:
    inset -1px -1px #0a0a0a,
    inset 1px 1px #fff,
    inset -2px -2px grey,
    inset 2px 2px #dfdfdf !important;
  font-weight: 900 !important;
}

.center_everything {
  justify-content: center;
  align-items: center;
  display: flex;
}

.backoglogo {
  background-color: rgba(243, 244, 246, 0.645) !important;
}
.backoglogos {
  background-color: rgba(243, 244, 246, 0.645) !important;
}

.backgrond_toolbar {
  background-color: #f5f5f576 !important;
  border: 1.4px solid #000;
  justify-content: center;
  align-items: center;
}

.sunken-panel {
  background-color: #9b9b9b95 !important;
  padding: 10px;
}

table,
th,
td {
  border: 1px solid black !important;
}

th {
  background: silver;
  box-shadow:
    inset -1px -1px #0a0a0a,
    inset 1px 1px #fff,
    inset -2px -2px grey,
    inset 2px 2px #dfdfdf;
  box-sizing: border-box;
  font-weight: 400;
  height: 17px;
  padding: 0 6px;
  position: sticky;
  top: 0;
  text-align: center !important;
}

td {
  background: rgb(255, 255, 255);

  box-sizing: border-box;
  font-weight: 400;
  height: 17px;
  padding: 0 6px;
  position: sticky;
  top: 0;
  text-align: center !important;
}

.indicate_modal {
  justify-content: end;
  text-align: end;
  align-items: end;
}

.modalz {
  position: relative;
  top: 200px !important;
}

.centeralldivs {
  justify-content: center;
  align-items: center;
  text-align: center;
  display: grid;
}

.backoglogoss {
  background-color: #97979795 !important;
  width: 100% !important;
}

.mobile_top_button {
  position: fixed;
}
.padsa {
  padding: 2px;
  font-size: 10px !important;
  height: 65px !important;
  width: 100% !important;
  font-weight: 600 !important;
  background-color: #c1c1c1 !important;
  box-shadow:
    inset -1px -1px #0a0a0a,
    inset 1px 1px #fff,
    inset -2px -2px grey,
    inset 2px 2px #dfdfdf !important;
  box-sizing: border-box;
  text-align: center !important;
}

.buttonback {
  box-shadow:
    inset 1px 1px #a4a4a4,
    inset 1px 1px #fff,
    inset 2px 2px grey,
    inset 2px 2px #dfdfdf;
  box-sizing: border-box;
  font-weight: 600;
  width: 100%;

  position: sticky;
  top: 0;
  text-align: center !important;

  background-color: #c1c1c1 !important;
}

.buttonback {
  font-size: 13px !important;
}
.cabutton {
  font-size: 12px !important;
  font-weight: 600 !important;
}

.buttonbackg {
  box-shadow:
    inset 1px 1px #a4a4a4,
    inset 1px 1px #fff,
    inset 2px 2px grey,
    inset 2px 2px #dfdfdf;
  box-sizing: border-box;
  font-weight: 600;
  width: 100%;
  height: 80px !important;
  position: sticky;
  top: 0;
  text-align: center !important;

  background-color: #c1c1c1 !important;
}

.buttonbackg {
  font-size: 13px !important;
}

.video-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1 !important;

  height: 100%;
  overflow: hidden;
}

.centeralldivss {
  text-align: center;
  justify-content: center;
  align-items: center;
}

.heal {
  font-size: 15px !important;
  color: #000000 !important;
  font-weight: 600 !important;
  text-align: center;
  padding: 8px;
}

.video-content {
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Adjust the color and opacity of the overlay */
}

.kHZkoY {
  height: 33px;
  line-height: 33px;
  padding-left: 0.25rem;
  padding-right: 3px;
  background: linear-gradient(90deg, navy, #1084d0) !important;
  font-weight: bold;
  border: 2px solid rgb(198, 198, 198);
  /* background: rgb(6, 0, 132); */
  color: rgb(254, 254, 254);
}

.fonttop {
  font-size: 11px !important;
}
.fonttops {
  font-size: 8px !important;
}

.widthbuttoncloseopen {
  width: 25px !important;
  height: 24px !important;
}

.fontoftextsmall {
  font-size: 14px !important;
  font-weight: 300 !important;
}

kHZkoY {
  background-color: #4a668b !important;
}

.fonttopbutton {
  font-size: 13px !important;
  color: #1084d0;
}

.textsa {
  padding: 12px;
  font-size: 20px !important;
  color: #000000;
  font-weight: 700;
}

.ovHgy {
  position: relative;
  padding: 4px;
  font-size: 1rem;
  border-style: solid;
  border-width: 2px;
  border-color: rgb(223, 223, 223) rgb(10, 10, 10) rgb(10, 10, 10)
    rgb(223, 223, 223);
  box-shadow: none !important;
  box-sizing: border-box;
  display: inline-block;
  background: rgb(198, 198, 198);
  color: rgb(10, 10, 10);
}

.footerdes {
  font-size: 13px !important;
  line-height: 30px !important;
  font-weight: 600 !important;
}

.HOVERTABSANDSIZES {
  width: 100% !important;
  height: 70px !important;
  font-size: 40px !important;
  color: #1084d0 !important;
  box-shadow:
    inset -1px 0 #0a0a0a,
    inset 1px 1px #dfdfdf,
    inset -2px 0 grey,
    inset 2px 2px #fff !important;
}

.zindex {
  z-index: 1000px !important;
}

.backoffg {
  background-color: #0a0a0a77;
}

.fontseek {
  color: #fff !important;
  font-size: 1.2rem !important;
  text-align: center;
  font-weight: 600 !important;
}

.backofseekbox {
  color: #25c660 !important;
  padding: 20px !important;
  background-color: #d1d5db !important;
  border: 2px solid #000;
  --tw-shadow: 2px 2px 5px #888, -2px -2px 5px #fff !important;
  --tw-shadow-colored:
    2px 2px 5px var(--tw-shadow-color), -2px -2px 5px var(--tw-shadow-color) !important;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow) !important;
}

.backofseekboxtext {
  color: #0cb54a !important;
  font-size: 16px !important;
  line-height: 40px;
  padding: 20px !important;
  font-weight: 500 !important;
}
.backofseekboxtexta {
  color: #7a009c !important;
  font-size: 16px !important;
  line-height: 40px;
  padding: 20px !important;
  font-weight: 500 !important;
}
.backofseekboxtextp {
  color: #00009c !important;
  font-size: 16px !important;
  line-height: 40px;
  padding: 20px !important;
  font-weight: 500 !important;
}
@media screen and (min-width: 1000px) {
  .backofseekboxtext {
    color: #0cb54a !important;
    font-size: 24px !important;
    line-height: 40px;
    padding: 20px !important;
    font-weight: 500 !important;
  }
  .backofseekboxtexta {
    color: #7a009c !important;
    font-size: 24px !important;
    line-height: 40px;
    padding: 20px !important;
    font-weight: 500 !important;
  }
  .backofseekboxtextp {
    color: #00009c !important;
    font-size: 24px !important;
    line-height: 40px;
    padding: 20px !important;
    font-weight: 500 !important;
  }
}

.title-bar-text {
  color: #fff;
  font-size: 14px !important;
  font-weight: 700;
  letter-spacing: 0;
  margin-right: 24px;
}

.buttonss {
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  color: transparent;
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Monaco,
    Consolas,
    Liberation Mono,
    Courier New,
    monospace !important;
  background: silver;
  box-shadow:
    inset -1px -1px #0a0a0a,
    inset 1px 1px #fff,
    inset -2px -2px grey,
    inset 2px 2px #dfdfdf;
  min-height: 37px !important;
  min-width: 75px;
  padding: 0 12px;
  text-shadow: 0 0 #222;
}

.centerbutton {
  justify-content: center;
  align-items: center;
  display: flex;
}

.fonan {
  font-size: 10px !important;
}

.backofseekboxtextff {
  font-size: 16px !important;
  text-align: start;
}

.backofseekboxtexts {
  background-color: rgba(225, 225, 225, 0.829) !important;
}

.roadmap-title {
  text-align: center;
  font-size: 2rem;
  color: #ff0095;
  margin-bottom: 1.5rem;
}

.roadmap-phase h3,
.roadmap-next h3 {
  font-size: 1.4rem;
  color: #87cefa;
  margin-bottom: 0.5rem;
}

.roadmap-list {
  list-style-type: '🌸 ';
  padding-left: 1.2rem;
}

.roadmap-list li {
  margin-bottom: 0.6rem;
  font-size: 1.1rem;
  line-height: 1.6;
}

.tba {
  font-style: italic;
  color: #aaa;
  font-size: 1.05rem;
  padding-left: 1.2rem;
}

.image-content {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Optional dim effect */
  z-index: 1;
}

.mobile-bg img.image-content {
  display: block;
}

.faq-title {
  font-size: 1rem;
  color: #000000;
  margin-bottom: 2rem;
}

.faq-item {
  margin-bottom: 1.5rem;
}

.faq-question {
  font-weight: bold;
  text-align: start;
  color: #454545;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.faq-answer {
  font-size: 0.85rem;
  color: #000000;
  margin: 0 auto;
  max-width: 90%;
  line-height: 1.6;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .faq-section {
  }

  .faq-title {
    font-size: 13px !important;
  }

  .faq-question {
    font-size: 13px !important;
  }

  .faq-answer {
    font-size: 13px !important;
    text-align: start;
  }
}

.textvs {
  position: relative;
  top: 40px !important;
}
@media (max-width: 768px) {
  .textvs {
    position: relative;
    top: 0px !important;
  }
}

.centeritalls {
  justify-content: center;
  align-items: center;
  display: flex;
  text-align: center;
}

.submit-container {
  max-width: 500px;
  margin: 40px auto;
  padding: 20px;
  background: #f3f3f3;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.submit-container h2 {
  text-align: center;
  margin-bottom: 20px;
}

.submit-container input {
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.submit-container button {
  width: 100%;
  padding: 12px;
  background: #3b82f6;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.gallery {
  padding: 40px;
  text-align: center;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.art-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.art-card img {
  width: 100%;
  border-radius: 8px;
}

.Appsss {
  background-color: #feb4ff;
}

.centerani {
  text-align: center;
  color: #ffffff;
  font-size: 30px !important;
  font-weight: 600;
  padding: 10px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

/* Modal overlay */
.dev-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(58, 58, 58, 0.836); /* light brown overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Modal content */
.dev-modal {
  background: #000000;
  padding: 30px 50px;
  border-radius: 1px;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
  text-align: center;
  border: 2px solid #fff;
  max-width: 90%;
  width: 400px;
}

.dev-modal h2 {
  font-size: 1.5rem;
  color: #ffffff;
  font-weight: 600;
}

/* Responsive design */
@media (max-width: 600px) {
  .dev-modal {
    width: 85%;
    padding: 20px 25px;
  }

  .dev-modal h2 {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;EACE,oBAAoB,EAAE,iCAAiC;AACzD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;;EAE5B,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,uCAAuC;EACvC,iCAAiC;;EAEjC,yEAAyE;AAC3E;;AAEA,sDAAsD;;AAEtD,8BAA8B;;AAE9B;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,qCAAqC;AACvC;AACA;EACE;IACE,6CAA6C;IAC7C,0BAA0B;IAC1B,qCAAqC;EACvC;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,kEAAkE;EAClE,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,+CAA+C;AACjD;AACA;EACE;IACE,kEAAkE;IAClE,gBAAgB;IAChB,eAAe;IACf,wCAAwC;IACxC,+CAA+C;EACjD;AACF;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;;EAEtB,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,uDAAuD;EACvD,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,yCAAyC;EACzC,oCAAoC;EACpC;;;;oCAIkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,aAAa;AACf;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB;;;;yBAIuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;;EAE9B,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;EACpC;;;;oCAIkC;EAClC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE;;;;yBAIuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;;EAEX,gBAAgB;EAChB,MAAM;EACN,6BAA6B;;EAE7B,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE;;;;yBAIuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,MAAM;EACN,6BAA6B;;EAE7B,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,sBAAsB;;EAEtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,4DAA4D;EAC5D,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB;sBACoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB;;;;iCAI+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,oCAAoC;EACpC,sBAAsB;EACtB,4DAA4D;EAC5D;uFACqF;EACrF;;+BAE6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,iBAAiB;IACjB,wBAAwB;IACxB,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,iBAAiB;IACjB,wBAAwB;IACxB,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,iBAAiB;IACjB,wBAAwB;IACxB,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB;;;;;;;;wBAQsB;EACtB,kBAAkB;EAClB;;;;yBAIuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,wBAAwB;EACxD,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;EACA;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mCAAmC,EAAE,wBAAwB;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  --tw-bg-opacity: 0.5; /* Adjust the opacity as needed */\n}\n\n* {\n  font-size: 20px !important;\n}\n\nbody {\n  background-color: #000000;\n}\n\n.desk {\n  cursor: url() !important;\n  background-attachment: fixed;\n\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n}\n\n.mob {\n  background-attachment: fixed;\n  background-image: url('') !important;\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n\n  /* Set the background color with opacity and color using a CSS variable */\n}\n\n/* Additional font-face rules if you have more fonts */\n\n/* Define global font styles */\n\n.top_nav {\n  font-size: 24px;\n}\n\n.a {\n  background-color: rgb(239, 183, 0) !important;\n  font-size: 17px !important;\n  text-decoration: underline !important;\n}\n@media screen and (min-width: 1000px) {\n  .a {\n    background-color: rgb(239, 183, 0) !important;\n    font-size: 20px !important;\n    text-decoration: underline !important;\n  }\n}\n\n.header-img {\n  height: 18px;\n}\n\n.header-img-logo {\n  height: 60px;\n}\n\n.hr_first {\n  height: 11px !important;\n  border-width: 0 !important;\n  color: rgb(0, 47, 255) !important;\n  background-color: rgb(255, 17, 0) !important;\n}\n\n.HarryPotterObamaSonic10Inu {\n  background: linear-gradient(to right, #e0b700, #eed600) !important;\n  font-weight: 800;\n  font-size: 20px;\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n}\n@media screen and (min-width: 1000px) {\n  .HarryPotterObamaSonic10Inu {\n    background: linear-gradient(to right, #e0b700, #eed600) !important;\n    font-weight: 800;\n    font-size: 30px;\n    -webkit-background-clip: text !important;\n    -webkit-text-fill-color: transparent !important;\n  }\n}\n.ca {\n  font-size: 1rem;\n  color: #fff;\n  font-weight: 600;\n}\n@media screen and (min-width: 1000px) {\n  .ca {\n    font-size: 1.3rem;\n    color: #fff;\n    font-weight: 600;\n  }\n}\n\n.addy {\n  color: #26c6da;\n}\n\n.top_a {\n  width: 100%;\n  height: 100%;\n}\n\n.header-imgs {\n  height: 108px;\n}\n\n.cas {\n  font-size: 2.3rem;\n  color: #fff;\n  font-weight: 600;\n}\n\n.top_as {\n  width: 60%;\n  height: 100%;\n}\n\n.cass {\n  font-size: 1.3rem;\n  color: #70fff3;\n  font-weight: 600;\n}\n\n.hr_firsts {\n  height: 4px !important;\n\n  color: rgb(255, 255, 255) !important;\n  background-color: rgb(255, 255, 255) !important;\n}\n\n.button_back {\n  background-color: rgba(255, 255, 255, 0.748) !important;\n  border-radius: 15px !important;\n}\n\n.iframe-container {\n  position: relative;\n  width: 100%;\n  /* 16:9 aspect ratio (height / width) */\n}\n\n.iframe-container iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n}\n\n.iframe-containerz {\n  position: relative;\n  width: 100%;\n  /* 16:9 aspect ratio (height / width) */\n}\n\n.iframe-containerz iframe {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n}\n\n.modl {\n  background-color: #26c5da15 !important;\n}\n.yes-no-buttons {\n  background-color: rgb(0, 0, 0) !important;\n  color: rgb(255, 255, 255) !important;\n  box-shadow:\n    inset -1px -1px #0a0a0a,\n    inset 1px 1px #fff,\n    inset -2px -2px grey,\n    inset 2px 2px #dfdfdf !important;\n  font-weight: 900 !important;\n}\n\n.center_everything {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n\n.backoglogo {\n  background-color: rgba(243, 244, 246, 0.645) !important;\n}\n.backoglogos {\n  background-color: rgba(243, 244, 246, 0.645) !important;\n}\n\n.backgrond_toolbar {\n  background-color: #f5f5f576 !important;\n  border: 1.4px solid #000;\n  justify-content: center;\n  align-items: center;\n}\n\n.sunken-panel {\n  background-color: #9b9b9b95 !important;\n  padding: 10px;\n}\n\ntable,\nth,\ntd {\n  border: 1px solid black !important;\n}\n\nth {\n  background: silver;\n  box-shadow:\n    inset -1px -1px #0a0a0a,\n    inset 1px 1px #fff,\n    inset -2px -2px grey,\n    inset 2px 2px #dfdfdf;\n  box-sizing: border-box;\n  font-weight: 400;\n  height: 17px;\n  padding: 0 6px;\n  position: sticky;\n  top: 0;\n  text-align: center !important;\n}\n\ntd {\n  background: rgb(255, 255, 255);\n\n  box-sizing: border-box;\n  font-weight: 400;\n  height: 17px;\n  padding: 0 6px;\n  position: sticky;\n  top: 0;\n  text-align: center !important;\n}\n\n.indicate_modal {\n  justify-content: end;\n  text-align: end;\n  align-items: end;\n}\n\n.modalz {\n  position: relative;\n  top: 200px !important;\n}\n\n.centeralldivs {\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  display: grid;\n}\n\n.backoglogoss {\n  background-color: #97979795 !important;\n  width: 100% !important;\n}\n\n.mobile_top_button {\n  position: fixed;\n}\n.padsa {\n  padding: 2px;\n  font-size: 10px !important;\n  height: 65px !important;\n  width: 100% !important;\n  font-weight: 600 !important;\n  background-color: #c1c1c1 !important;\n  box-shadow:\n    inset -1px -1px #0a0a0a,\n    inset 1px 1px #fff,\n    inset -2px -2px grey,\n    inset 2px 2px #dfdfdf !important;\n  box-sizing: border-box;\n  text-align: center !important;\n}\n\n.buttonback {\n  box-shadow:\n    inset 1px 1px #a4a4a4,\n    inset 1px 1px #fff,\n    inset 2px 2px grey,\n    inset 2px 2px #dfdfdf;\n  box-sizing: border-box;\n  font-weight: 600;\n  width: 100%;\n\n  position: sticky;\n  top: 0;\n  text-align: center !important;\n\n  background-color: #c1c1c1 !important;\n}\n\n.buttonback {\n  font-size: 13px !important;\n}\n.cabutton {\n  font-size: 12px !important;\n  font-weight: 600 !important;\n}\n\n.buttonbackg {\n  box-shadow:\n    inset 1px 1px #a4a4a4,\n    inset 1px 1px #fff,\n    inset 2px 2px grey,\n    inset 2px 2px #dfdfdf;\n  box-sizing: border-box;\n  font-weight: 600;\n  width: 100%;\n  height: 80px !important;\n  position: sticky;\n  top: 0;\n  text-align: center !important;\n\n  background-color: #c1c1c1 !important;\n}\n\n.buttonbackg {\n  font-size: 13px !important;\n}\n\n.video-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: -1 !important;\n\n  height: 100%;\n  overflow: hidden;\n}\n\n.centeralldivss {\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.heal {\n  font-size: 15px !important;\n  color: #000000 !important;\n  font-weight: 600 !important;\n  text-align: center;\n  padding: 8px;\n}\n\n.video-content {\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: -1;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* Adjust the color and opacity of the overlay */\n}\n\n.kHZkoY {\n  height: 33px;\n  line-height: 33px;\n  padding-left: 0.25rem;\n  padding-right: 3px;\n  background: linear-gradient(90deg, navy, #1084d0) !important;\n  font-weight: bold;\n  border: 2px solid rgb(198, 198, 198);\n  /* background: rgb(6, 0, 132); */\n  color: rgb(254, 254, 254);\n}\n\n.fonttop {\n  font-size: 11px !important;\n}\n.fonttops {\n  font-size: 8px !important;\n}\n\n.widthbuttoncloseopen {\n  width: 25px !important;\n  height: 24px !important;\n}\n\n.fontoftextsmall {\n  font-size: 14px !important;\n  font-weight: 300 !important;\n}\n\nkHZkoY {\n  background-color: #4a668b !important;\n}\n\n.fonttopbutton {\n  font-size: 13px !important;\n  color: #1084d0;\n}\n\n.textsa {\n  padding: 12px;\n  font-size: 20px !important;\n  color: #000000;\n  font-weight: 700;\n}\n\n.ovHgy {\n  position: relative;\n  padding: 4px;\n  font-size: 1rem;\n  border-style: solid;\n  border-width: 2px;\n  border-color: rgb(223, 223, 223) rgb(10, 10, 10) rgb(10, 10, 10)\n    rgb(223, 223, 223);\n  box-shadow: none !important;\n  box-sizing: border-box;\n  display: inline-block;\n  background: rgb(198, 198, 198);\n  color: rgb(10, 10, 10);\n}\n\n.footerdes {\n  font-size: 13px !important;\n  line-height: 30px !important;\n  font-weight: 600 !important;\n}\n\n.HOVERTABSANDSIZES {\n  width: 100% !important;\n  height: 70px !important;\n  font-size: 40px !important;\n  color: #1084d0 !important;\n  box-shadow:\n    inset -1px 0 #0a0a0a,\n    inset 1px 1px #dfdfdf,\n    inset -2px 0 grey,\n    inset 2px 2px #fff !important;\n}\n\n.zindex {\n  z-index: 1000px !important;\n}\n\n.backoffg {\n  background-color: #0a0a0a77;\n}\n\n.fontseek {\n  color: #fff !important;\n  font-size: 1.2rem !important;\n  text-align: center;\n  font-weight: 600 !important;\n}\n\n.backofseekbox {\n  color: #25c660 !important;\n  padding: 20px !important;\n  background-color: #d1d5db !important;\n  border: 2px solid #000;\n  --tw-shadow: 2px 2px 5px #888, -2px -2px 5px #fff !important;\n  --tw-shadow-colored:\n    2px 2px 5px var(--tw-shadow-color), -2px -2px 5px var(--tw-shadow-color) !important;\n  box-shadow:\n    var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),\n    var(--tw-shadow) !important;\n}\n\n.backofseekboxtext {\n  color: #0cb54a !important;\n  font-size: 16px !important;\n  line-height: 40px;\n  padding: 20px !important;\n  font-weight: 500 !important;\n}\n.backofseekboxtexta {\n  color: #7a009c !important;\n  font-size: 16px !important;\n  line-height: 40px;\n  padding: 20px !important;\n  font-weight: 500 !important;\n}\n.backofseekboxtextp {\n  color: #00009c !important;\n  font-size: 16px !important;\n  line-height: 40px;\n  padding: 20px !important;\n  font-weight: 500 !important;\n}\n@media screen and (min-width: 1000px) {\n  .backofseekboxtext {\n    color: #0cb54a !important;\n    font-size: 24px !important;\n    line-height: 40px;\n    padding: 20px !important;\n    font-weight: 500 !important;\n  }\n  .backofseekboxtexta {\n    color: #7a009c !important;\n    font-size: 24px !important;\n    line-height: 40px;\n    padding: 20px !important;\n    font-weight: 500 !important;\n  }\n  .backofseekboxtextp {\n    color: #00009c !important;\n    font-size: 24px !important;\n    line-height: 40px;\n    padding: 20px !important;\n    font-weight: 500 !important;\n  }\n}\n\n.title-bar-text {\n  color: #fff;\n  font-size: 14px !important;\n  font-weight: 700;\n  letter-spacing: 0;\n  margin-right: 24px;\n}\n\n.buttonss {\n  border: none;\n  border-radius: 0;\n  box-sizing: border-box;\n  color: transparent;\n  font-family:\n    ui-monospace,\n    SFMono-Regular,\n    Menlo,\n    Monaco,\n    Consolas,\n    Liberation Mono,\n    Courier New,\n    monospace !important;\n  background: silver;\n  box-shadow:\n    inset -1px -1px #0a0a0a,\n    inset 1px 1px #fff,\n    inset -2px -2px grey,\n    inset 2px 2px #dfdfdf;\n  min-height: 37px !important;\n  min-width: 75px;\n  padding: 0 12px;\n  text-shadow: 0 0 #222;\n}\n\n.centerbutton {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n\n.fonan {\n  font-size: 10px !important;\n}\n\n.backofseekboxtextff {\n  font-size: 16px !important;\n  text-align: start;\n}\n\n.backofseekboxtexts {\n  background-color: rgba(225, 225, 225, 0.829) !important;\n}\n\n.roadmap-title {\n  text-align: center;\n  font-size: 2rem;\n  color: #ff0095;\n  margin-bottom: 1.5rem;\n}\n\n.roadmap-phase h3,\n.roadmap-next h3 {\n  font-size: 1.4rem;\n  color: #87cefa;\n  margin-bottom: 0.5rem;\n}\n\n.roadmap-list {\n  list-style-type: '🌸 ';\n  padding-left: 1.2rem;\n}\n\n.roadmap-list li {\n  margin-bottom: 0.6rem;\n  font-size: 1.1rem;\n  line-height: 1.6;\n}\n\n.tba {\n  font-style: italic;\n  color: #aaa;\n  font-size: 1.05rem;\n  padding-left: 1.2rem;\n}\n\n.image-content {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Optional dim effect */\n  z-index: 1;\n}\n\n.mobile-bg img.image-content {\n  display: block;\n}\n\n.faq-title {\n  font-size: 1rem;\n  color: #000000;\n  margin-bottom: 2rem;\n}\n\n.faq-item {\n  margin-bottom: 1.5rem;\n}\n\n.faq-question {\n  font-weight: bold;\n  text-align: start;\n  color: #454545;\n  font-size: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.faq-answer {\n  font-size: 0.85rem;\n  color: #000000;\n  margin: 0 auto;\n  max-width: 90%;\n  line-height: 1.6;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .faq-section {\n  }\n\n  .faq-title {\n    font-size: 13px !important;\n  }\n\n  .faq-question {\n    font-size: 13px !important;\n  }\n\n  .faq-answer {\n    font-size: 13px !important;\n    text-align: start;\n  }\n}\n\n.textvs {\n  position: relative;\n  top: 40px !important;\n}\n@media (max-width: 768px) {\n  .textvs {\n    position: relative;\n    top: 0px !important;\n  }\n}\n\n.centeritalls {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  text-align: center;\n}\n\n.submit-container {\n  max-width: 500px;\n  margin: 40px auto;\n  padding: 20px;\n  background: #f3f3f3;\n  border-radius: 12px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.submit-container h2 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.submit-container input {\n  width: 100%;\n  padding: 12px;\n  margin-bottom: 12px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n}\n\n.submit-container button {\n  width: 100%;\n  padding: 12px;\n  background: #3b82f6;\n  color: white;\n  font-weight: bold;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.gallery {\n  padding: 40px;\n  text-align: center;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.art-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 10px;\n}\n\n.art-card img {\n  width: 100%;\n  border-radius: 8px;\n}\n\n.Appsss {\n  background-color: #feb4ff;\n}\n\n.centerani {\n  text-align: center;\n  color: #ffffff;\n  font-size: 30px !important;\n  font-weight: 600;\n  padding: 10px;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3);\n}\n\n/* Modal overlay */\n.dev-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(58, 58, 58, 0.836); /* light brown overlay */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n/* Modal content */\n.dev-modal {\n  background: #000000;\n  padding: 30px 50px;\n  border-radius: 1px;\n  box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);\n  text-align: center;\n  border: 2px solid #fff;\n  max-width: 90%;\n  width: 400px;\n}\n\n.dev-modal h2 {\n  font-size: 1.5rem;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n/* Responsive design */\n@media (max-width: 600px) {\n  .dev-modal {\n    width: 85%;\n    padding: 20px 25px;\n  }\n\n  .dev-modal h2 {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
